import { ConfigConsumerProps } from '../config-provider/configConsumerProps';
import { omit } from 'lodash-es';

export default {
  name: 'FcMenu',
  props: {
    // 收起开关
    showCollapsed: {
      type: Boolean,
      default: false,
    },
    // 侧边菜单
    sideCollapsed: {
      type: Boolean,
      default: false,
    },
    // 下部菜单
    bottomCollapsed: {
      type: Boolean,
      default: false,
    },
    // 默认收起
    defaultCollapsed: {
      type: Boolean,
      default: false,
    },
    meauColumn: {
      type: Array,
      default: () => {},
    },
    menu: {
      type: Array,
      default: () => {},
    },
    width: {
      type: Number,
      default: 200,
    },
    // 用于控制水平菜单在折叠和展开状态之间切换。
    // 用户可以点击折叠的菜单项来展开或收起菜单项的文本内容。
    inlineIndent: {
      type: Number,
      default: 20,
    },
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      collapsed: this.defaultCollapsed,
    };
  },

  created() {},
  mounted() {},
  watch: {
    collapsed: {
      immediate: true, // 立即执行
      handler(varl) {
        if (varl) {
          this.$refs.scrollbar.$el.scrollTop = 0; //航栏节点展开后，一页无法展示的情况下，进行收起，收起后需要回滚到顶部
        }
      },
    },
  },
  methods: {
    // 切换坍塌属性
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
      this.$emit('toggleCollapsed', this.collapsed);
    },
  },
  render() {
    const { meauColumn, width, menu, $attrs, _props, $listeners, $scopedSlots, $slots } = this;
    const menuData = menu || meauColumn;
    const { style } = _props;
    const { getPrefixCls } = this.configProvider;
    const prefixCls = getPrefixCls('', 'fc-menu');
    const menuList = (data, isIcon, deep, pre) => {
      //deep: 菜单深度
      //pre: 上一级菜单 距离左侧距离
      //为了实现菜单边距20，且存在是否有图标两种情况（无图标距离左侧20，有图标距离左侧28，图标与文字间距离28）的目的，使用递归来处理多种情况
      return data.map(item => {
        // 叶子节点
        if (!item.children || item.children.length == 0) {
          return (
            <a-menu-item
              key={item.key}
              {...{ props: item.props }}
              onClick={value => {
                this.$emit('click', { data: item, ...value });
              }}
            >
              {$scopedSlots.menuItem ? (
                <span class="menuLine">
                  {item.icon && (
                    <fc-icon
                      style={`margin-left:${isIcon ? pre + 8 + 'px' : pre + 'px'}`}
                      className={`${item.icon} menuIcon`}
                    ></fc-icon>
                  )}
                  <span
                    class="menuLine-text-content"
                    style={`margin-left:${
                      item.icon ? 0 : isIcon && !item.icon ? pre + 8 + 'px' : pre + 'px'
                    }`}
                  >
                    {$scopedSlots.menuItem({ item })}
                  </span>
                </span>
              ) : (
                <span class="menuLine">
                  {item.icon && (
                    <fc-icon
                      style={`margin-left:${isIcon ? pre + 8 + 'px' : pre + 'px'}`}
                      className={`${item.icon} menuIcon`}
                    ></fc-icon>
                  )}
                  <span
                    class="menuLine-text-content"
                    style={`margin-left:${
                      item.icon ? 0 : isIcon && !item.icon ? pre + 8 + 'px' : pre + 'px'
                    }`}
                  >
                    {item.name}
                  </span>
                </span>
              )}
            </a-menu-item>
          );
        } else {
          // 非叶子节点
          const newDeep = deep + 1;
          const newPre = pre + (isIcon ? (deep === 0 ? 0 : 8) : 0);
          return (
            <a-sub-menu
              key={item.key}
              {...{ props: item.props }}
              {...{ on: item.on }}
              class={
                $attrs.defaultSelectedKeys.includes(item.key)
                  ? `${prefixCls}-selected-sub-menu `
                  : ''
              }
            >
              <span slot="title" style="width: 100%">
                {$scopedSlots.subMenu ? (
                  <span class="menuLine">
                    {item.icon && (
                      <fc-icon
                        style={`margin-left:${isIcon ? pre + 8 + 'px' : pre + 'px'}`}
                        className={`${item.icon} menuIcon`}
                      ></fc-icon>
                    )}
                    <span
                      class="menuLine-text-content"
                      style={`margin-left:${
                        item.icon ? 0 : isIcon && !item.icon ? pre + 8 + 'px' : pre + 'px'
                      }`}
                    >
                      {$scopedSlots.subMenu({ item })}
                    </span>
                  </span>
                ) : (
                  <span class="menuLine">
                    {item.icon && (
                      <fc-icon
                        style={`margin-left:${isIcon ? pre + 8 + 'px' : pre + 'px'}`}
                        className={`${item.icon} menuIcon`}
                      ></fc-icon>
                    )}
                    <span
                      class="menuLine-text-content"
                      style={`margin-left:${
                        item.icon ? 0 : isIcon && !item.icon ? pre + 8 + 'px' : pre + 'px'
                      }`}
                    >
                      {item.name}
                    </span>
                  </span>
                )}
              </span>
              {menuList(item.children, item.icon, newDeep, newPre)}
            </a-sub-menu>
          );
        }
      });
    };
    return (
      <div
        class={prefixCls}
        style={{ ...{ width: `${!this.collapsed ? width + 'px' : '64px'}` }, ...style }}
      >
        <perfect-scrollbar
          ref="scrollbar"
          style={{ ...{ width: `${!this.collapsed ? width + 'px' : '64px'}` } }}
        >
          <a-menu
            style={{ ...{ width: `${!this.collapsed ? width + 'px' : '64px'}` } }}
            {...{ props: $attrs }}
            {...{ on: omit($listeners, 'click') }}
            inline-collapsed={this.collapsed}
            inline-indent={this.inlineIndent}
          >
            {menuList(menuData, undefined, 0, 0)}
          </a-menu>
        </perfect-scrollbar>
        {this.showCollapsed && this.bottomCollapsed ? (
          <a-button class={prefixCls + '-button'} type="link" onClick={this.toggleCollapsed}>
            <a-icon type={this.collapsed ? 'menu-unfold' : 'menu-fold'} />
          </a-button>
        ) : null}
        {this.showCollapsed && this.sideCollapsed ? (
          <a-button class={prefixCls + '-button_side'} type="link" onClick={this.toggleCollapsed}>
            <fc-icon className={this.collapsed ? 'FCyou-xian' : 'FCzuo-xian'} />
          </a-button>
        ) : null}
      </div>
    );
  },
};
